import { Money } from "@/components/Money";
import { ReportCard } from "@/components/reports/ReportCard";
import { fmtQty, round3 } from "@/lib/format";

const Stat = ({ label, children, testid, accent }) => (
  <div className={`rounded-md border px-4 py-3 ${accent ? "border-teal-200 bg-teal-50/60" : "border-slate-200 bg-slate-50"}`}>
    <div className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">{label}</div>
    <div className="mt-1 text-lg font-semibold text-slate-900" data-testid={testid}>{children}</div>
  </div>
);

const Dash = () => <span className="num">—</span>;

export const CostPerUnit = ({ data, params, disabled }) => {
  const t = data.totals;
  const products = data.products || [];
  const tq = round3(products.reduce((s, p) => s + p.quantity, 0));
  const tc = round3(products.reduce((s, p) => s + p.cost, 0));
  return (
    <ReportCard id="cost_per_unit" title="Cost per Unit Sold" description="Overall = COGS (sales report Cost) ÷ quantity sold · per item = item COGS ÷ item quantity sold" params={params} disabled={disabled}>
      <div className="grid gap-3 sm:grid-cols-3">
        <Stat label="Cost of goods sold" testid="cpu-cogs"><Money value={t.cogs} /></Stat>
        <Stat label="Quantity sold" testid="cpu-qty"><span className="num">{fmtQty(t.qty_sold)}</span></Stat>
        <Stat label="Cost per unit" testid="cpu-overall" accent>{t.cost_per_unit == null ? <Dash /> : <Money value={t.cost_per_unit} />}</Stat>
      </div>
      <table className="mt-6 w-full text-sm" data-testid="cpu-products-table">
        <thead className="bg-slate-50 text-xs font-semibold uppercase tracking-wider text-slate-500">
          <tr><th className="px-4 py-2.5 text-left">Item</th><th className="px-4 py-2.5 text-right">Quantity sold</th><th className="px-4 py-2.5 text-right">COGS</th><th className="px-4 py-2.5 text-right">Cost per unit</th></tr>
        </thead>
        <tbody>
          {products.length === 0 && <tr><td colSpan={4} className="px-4 py-6 text-center text-slate-500" data-testid="cpu-empty">No sales in this period — cost per unit: —</td></tr>}
          {products.map((p) => (
            <tr key={p.item} className="row-hover border-t border-slate-100" data-testid={`cpu-row-${p.item}`}>
              <td className="px-4 py-2 text-slate-800">{p.product}</td>
              <td className="num px-4 py-2 text-right">{fmtQty(p.quantity)}</td>
              <td className="px-4 py-2 text-right"><Money value={p.cost} /></td>
              <td className="px-4 py-2 text-right">{p.cost_per_unit == null ? <Dash /> : <Money value={p.cost_per_unit} />}</td>
            </tr>
          ))}
          {products.length > 0 && (
            <tr className="border-t-2 border-slate-900 bg-slate-50 font-semibold" data-testid="cpu-total-row">
              <td className="px-4 py-2.5">Total</td><td className="num px-4 py-2.5 text-right">{fmtQty(tq)}</td>
              <td className="px-4 py-2.5 text-right"><Money value={tc} /></td><td className="px-4 py-2.5 text-right">{tq > 0 ? <Money value={round3(tc / tq)} /> : <Dash />}</td>
            </tr>
          )}
        </tbody>
      </table>
    </ReportCard>
  );
};
